module.exports = __webpack_public_path__ + "media/images/stores2-2fa0780c29ed6fb4c69d314e8226e186.jpg";